import moment from "moment";

export const months = [
    '',
    'Jan.',
    'Feb.',
    'Márc.',
    'Ápr.',
    'Máj.',
    'Jún.',
    'Júl.',
    'Aug.',
    'Szept.',
    'Okt.',
    'Nov.',
    'Dec.'
]

export function only_numbers(event)
{
    let e = event || window.event; //window.event is safer, thanks @ThiefMaster
    let charCode = e.which || e.keyCode;

    //point, backspace, shift
    if (charCode == 190 || charCode == 8 || charCode == 37 || charCode == 39
        || (e.key >= 0 && e.key <= 9 && e.key !== ' ')) {
        return true;
    }

    event.preventDefault();
}

export function parseFloatNan(val) {
    if(!Number.isInteger(val)) {
        return 0;
    }

    return parseFloat(val);
}

export function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}

export function formatShortDate(value) {
    if (value) {
        let year = moment(String(value)).format('YYYY');
        let month = moment(String(value)).format('MM');
        let day = moment(String(value)).format('DD');
        let hours = moment(String(value)).format('HH');
        let minutes = moment(String(value)).format('mm');

        return year + ' ' + months[parseInt(month)]+' '+parseInt(day)+', '+hours+':'+minutes;
    }
}

export function getShortMonth(date) {
    return months[parseInt(moment(String(date)).format('MM'))];
}

export function capitalize (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
}

export function getSetting(appSettings, name) {
    if(appSettings) {
        let st = appSettings.find(s => s.name.toUpperCase() == name.toUpperCase());

        if(st) {
            return st.value;
        }
    }

    return '';
}

export function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export function baseName(str)
{
    var base = new String(str).substring(str.lastIndexOf('/') + 1);
    if(base.lastIndexOf(".") != -1)
        base = base.substring(0, base.lastIndexOf("."));
    return base;
}

export const replaceAccents = function(s){
    var r=s.toLowerCase();
    r = r.replace(new RegExp(/\s/g),"");
    r = r.replace(new RegExp(/[àáâãäå]/g),"a");
    r = r.replace(new RegExp(/æ/g),"ae");
    r = r.replace(new RegExp(/ç/g),"c");
    r = r.replace(new RegExp(/[èéêë]/g),"e");
    r = r.replace(new RegExp(/[ìíîï]/g),"i");
    r = r.replace(new RegExp(/ñ/g),"n");
    r = r.replace(new RegExp(/[òóôõö]/g),"o");
    r = r.replace(new RegExp(/œ/g),"oe");
    r = r.replace(new RegExp(/[ùúûü]/g),"u");
    r = r.replace(new RegExp(/[ýÿ]/g),"y");
    r = r.replace(new RegExp(/\W/g),"");
    return r;
};
//ezt hasznaljuk accent removera
export const decodeEntities = (function() {
    // this prevents any overhead from creating the object each time
    var element = document.createElement('div');

    function decodeHTMLEntities (str) {
        if(str && typeof str === 'string') {
            // strip script/html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = '';
        }

        return str;
    }

    return decodeHTMLEntities;
})();
